
import React from "react";
import CustomerSupportAside from "./CustomerSupportAside";
import { Routes, Route } from "react-router-dom";
import CustomerSupportManagerFollowup from "./CustomerSupportManagerFollowup";
import CustomerSupportManagerData from "./CustomerSupportManagerData";
import CustomerSupportManagerCentralization from "./CustomerSupportManagerCentralization";
import CustomerSupportManagerChecklist from "./CustomerSupportManagerChecklist";

const CustomerSupportManager = () => {
    return (
        <div>
            <h2>Customer Support Manager</h2>
            <CustomerSupportAside />
            <Routes>
                <Route path="/C_S_M_Data" element={<CustomerSupportManagerData />} />
                <Route path="/C_S_M_Centralization" element={<CustomerSupportManagerCentralization />} />
                <Route path="/C_S_M_follow_up" element={<CustomerSupportManagerFollowup />} />
                <Route path="/C_S_M_Checklist" element={<CustomerSupportManagerChecklist />} />

            </Routes>
        </div>
    )
}

export default CustomerSupportManager;